import type { FaireProductEntity } from "../../entity_types/product";

export const p_b92ru2srjp: FaireProductEntity = {
  token: "p_b92ru2srjp",
  type: "product",
  name: "Whitnee Dainty Round Stone Dangle Earring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/49f60294e0b8c4661ae70a9ec346d964cf55cd9c9891160d9f980e0565e566de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d41b8c441331f5c63ecc736cd407c142508a95478828b9cceca643b0c4fe5994.jpeg",
    "https://cdn.faire.com/fastly/6294af8fe9b01a5bf0927ed4ab81bb80aa19cef96ad43e1dd47d1ebb3122a584.jpeg",
    "https://cdn.faire.com/fastly/5830c81595371d5abdbc9d3fd381b0ce56e4dcf1deab5e35aca645b835cc3328.jpeg",
  ],
  priceDollars: 6.92,
  description:
    "Dainty Round Stone Dangle Earring\n\n• Stainless Steel\n• Non-Tarnish\n• Green Stone\n• Measurement (L x W inch): 1 x 0.3\n• Lead-free, Nickel-safe",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:59.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
